import { array, mixed, object } from "yup";

/** A clause is "complete" when its value matches one of the populated shapes
 *  in `RuleClauseValue`: non-empty string for scalar operators, non-empty
 *  array for `IN`/`NOT_IN`. `null` / `""` / `[]` count as empty.
 *
 *  We branch by shape instead of using Yup's `string()` because `string()`
 *  silently coerces arrays via `String([...])`, which would make
 *  `["a", "b"]` pass / fail validation by accident of Yup's casting rules
 *  rather than by the form's intent.
 */
export const isClauseValueFilled = (value: unknown): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim().length > 0;
  if (Array.isArray(value)) {
    return value.some((item) => typeof item === "string" && item.trim().length > 0);
  }
  return false;
};

export const ruleClauseSchema = object({
  attribute: mixed<string>().nullable().required("Choose an attribute"),
  value: mixed<string | string[]>()
    .nullable()
    .test("rule-value-filled", "Select a value", (value) => isClauseValueFilled(value)),
});

/** Validation for a full `Rules` object — every clause that exists must be
 *  complete. The rule set / group themselves are optional (empty rules =
 *  no filtering); only clauses carry the per-field requirement. Inline
 *  errors render in `RulesSection` after submit. */
export const rulesSchema = object({
  groups: array().of(
    object({
      clauses: array().of(ruleClauseSchema),
    }),
  ),
});
